import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavSidebarService  {
  private isMinimizedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isMinimized$: Observable<boolean> = this.isMinimizedSubject.asObservable();

  constructor() { }

  sidebarWebToggle() {
    const bodyClass = document.getElementsByTagName('body')[0].className;
    const minimizeSidebarElement = document.getElementById('minimizeSidebar');
    if (!minimizeSidebarElement) return;
    
    const arrowBottomIcon = minimizeSidebarElement.children[0]?.classList;
    if (bodyClass.indexOf("sidebar-mini") == -1) {
      this.isMinimizedSubject.next(true);
      document.getElementsByTagName('body')[0].classList.add("sidebar-mini");
      if (arrowBottomIcon) {
        arrowBottomIcon.remove("nc-minimal-left");
        arrowBottomIcon.add("nc-minimal-right");
      }
      sessionStorage.setItem('hideDrawer',"true");
    } else {
      this.isMinimizedSubject.next(false);
      document.getElementsByTagName('body')[0].classList.remove("sidebar-mini");
      if (arrowBottomIcon) {
        arrowBottomIcon.remove("nc-minimal-right");
        arrowBottomIcon.add("nc-minimal-left");
      }
      sessionStorage.setItem('hideDrawer',"false");
    }
  }

  // Mobile sidebar toggle methods
  sidebarMobileToggle() {
    if (window.innerWidth >= 991) return; // Only work on mobile
    
    const html = document.getElementsByTagName('html')[0];
    const hasNavOpen = html.classList.contains('nav-open');
    
    if (hasNavOpen) {
      this.sidebarMobileClose();
    } else {
      this.sidebarMobileOpen();
    }
  }

  sidebarMobileOpen() {
    if (window.innerWidth >= 991) return; // Only work on mobile
    
    const html = document.getElementsByTagName('html')[0];
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    
    html.classList.add('nav-open');
    if (mainPanel) {
      mainPanel.style.position = 'fixed';
    }
    this.createBodyClickOverlay();
  }

  sidebarMobileClose() {
    if (window.innerWidth >= 991) return; // Only work on mobile
    
    const html = document.getElementsByTagName('html')[0];
    const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
    
    html.classList.remove('nav-open');
    if (mainPanel) {
      setTimeout(() => {
        mainPanel.style.position = '';
      }, 500);
    }
    this.removeBodyClickOverlay();
  }

  private createBodyClickOverlay() {
    this.removeBodyClickOverlay();
    
    const bodyClick = document.createElement('div');
    bodyClick.id = 'bodyClick';
    bodyClick.style.position = 'fixed';
    bodyClick.style.top = '0';
    bodyClick.style.left = '0';
    bodyClick.style.width = '100%';
    bodyClick.style.height = '100%';
    bodyClick.style.zIndex = '1029';
    bodyClick.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    bodyClick.addEventListener('click', () => {
      this.sidebarMobileClose();
    });
    document.body.appendChild(bodyClick);
  }

  private removeBodyClickOverlay() {
    const bodyClick = document.getElementById('bodyClick');
    if (bodyClick) {
      bodyClick.remove();
    }
  }

  isMobile(): boolean {
    return window.innerWidth < 991;
  }
}
